import React, { CSSProperties } from 'react';

import * as S from './styled';

interface IProps {
  color: string;
  style?: CSSProperties;
  title: string;
  weight?: string;
}

const ReusableTag = ({ color, style, title, weight = '700' }: IProps) => (
  <S.Wrapper style={{ ...style }} color={color}>
    <span style={{ fontWeight: weight }}>{title}</span>
  </S.Wrapper>
);
export default ReusableTag;
